import PropTypes from "prop-types";
import React, { useEffect, useCallback, useRef, useState } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
// import your pb client
import { pb } from "../../helpers/pocketbase_helper";

const MENU_CONFIG = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "ti-home",
    to: "/dashboard",
  },
  {
    key: "parametros",
    label: "Parámetros",
    icon: "ti-panel",
    subMenu: [
      {
        key: "usuarios",
        label: "Usuarios",
        to: "/usuarios",
      },
      {
        key: "clientes",
        label: "Clientes",
        to: "/clientes",
      },
      {
        key: "productos",
        label: "Productos",
        to: "/productos",
      },
      {
        key: "tipos_solicitud",
        label: "Tipos de Solicitud",
        to: "/tipos-solicitud",
      },
      {
        key: "tipos_pinza",
        label: "Tipos Pinza",
        to: "/tipos-pinza",
      },  
      {
        key: "proceso_proveedor",
        label: "Proveedores de Proceso",
        to: "/proceso-proveedor",
      },
      {
        key: "carga_parametros",
        label: "Carga de Parámetros",
        to: "/carga-parametros",
      },
      {
        key: "centro_costos",
        label: "Centro de Costos",
        icon: "dripicons-archive",
        subMenu: [
          {
            key: "maquina",
            label: "Máquina",
            to: "/centro-costo/maquina",
          },
          {
            key: "nuevo_centro_costo",
            label: "Agregar/Editar",
            to: "/centro-costo/centro-costo",
          },
          {
            key: "planificador_tareas",
            label: "Planificador Tareas",
            to: "/produccion/planificador-tareas",
          },
        ],
      },
      {
        key: "materiales",
        label: "Materiales",
        icon: "dripicons-archive",
        subMenu: [
          {
            key: "material",
            label: "Material",
            to: "/materiales/material",
          },
          {
            key: "medidas",
            label: "Medidas",
            to: "/materiales/medidas",
          },
          {
            key: "tipo_material",
            label: "Tipo de Material",
            to: "/materiales/tipo-material",
          },
          {
            key: "tintas",
            label: "Tintas",
            to: "/tintas",
          },
        ],
      },
      {
        key: "subprocesos",
        label: "Subprocesos",
        icon: "dripicons-archive",
        subMenu: [
          {
            key: "subbrillo",
            label: "Brillo",
            to: "/subprocesos/brillo",
          },
          {
            key: "subplastificado",
            label: "Plastificado",
            to: "/subprocesos/plastificado",
          },
          {
            key: "subpegue",
            label: "Pegue",
            to: "/subprocesos/pegue",
          },
          {
            key: "subtroquelado",
            label: "Troquelado",
            to: "/subprocesos/troquelado",
          },
          {
            key: "subacabados",
            label: "Acabados",
            to: "/subprocesos/acabados",
          },
        ],
      },
    ],
  },
  {
    key: "inventario",
    label: "Inventario",
    icon: "ti-package",
    subMenu: [
      {
        key: "materiales_op",
        label: "Materiales OP",
        subMenu: [
          {
            key: "unidad",
            label: "Unidad",
            to: "/inventarios/unidad",
          },
          {
            key: "inventarios_ingresos_egresos",
            label: "Ingresos/Egresos",
            to: "/inventarios/materiales",
          },
        ],
      },
      {
        key: "otros",
        label: "Otros",
        subMenu: [
          {
            key: "inventarios_entradas",
            label: "Entradas",
            to: "/inventarios/entradas",
          },
          {
            key: "inventarios_salidas",
            label: "Salidas",
            to: "/inventarios/salidas",
          },
          {
            key: "inventarios_solicitudes",
            label: "Solicitudes",
            to: "/inventarios/solicitudes",
          },
        ],
      },
    ],
  },
  {
    key: "ordenes_menu",
    label: "Ordenes Produccion",
    icon: "ti-folder",
    subMenu: [
      {
        key: "nueva_orden",
        label: "Agregar/Editar Orden",
        to: "/produccion/orden-produccion",
      },
      {
        key: "orden_activa",
        label: "Activas",
        icon: "dripicons-archive",
        subMenu: [
          {
            key: "ver_orden_activa",
            label: "Consultar",
            to: "/produccion/orden-produccion/activas",
          },
        ],
      },
      {
        key: "orden_finalizada",
        label: "Finalizadas",
        icon: "dripicons-archive",
        subMenu: [
          {
            key: "ver_orden_finalizada",
            label: "Consultar",
            to: "/produccion/orden-produccion/finalizadas",
          },
        ],
      },
    ]
  },

  {
    key: "produccion_menu",
    label: "Producción",
    icon: "ti-settings",
    subMenu: [
      {
        key: "tareas",
        label: "Tareas",
        to: "/produccion/tareas",
      },
      {
        key: "cola_operarios",
        label: "Cola de Tareas",
        to: "/produccion/cola-operarios",
      },
      {
        key: "cola_externa",
        label: "Externo",
        to: "/produccion/externo",
      },
    ],
  },
  {
    key: "exportacion",
    label: "Exportación",
    icon: "ti-download",
    subMenu: [
      {
        key: "centro_costos",
        label: "Centro de Costos",
        to: "/exportacion/centro-costos",
      },
      {
        key: "informe_op",
        label: "Informe OP",
        to: "/exportacion/informe-op",
      },
      {
        key: "informe_operarios",
        label: "Informe Operarios",
        to: "/exportacion/informe-operarios",
      },
      {
        key: "informe_reservas_inventario",
        label: "Informe Reservas Inventario",
        to: "/exportacion/informe-reservas-inventario",
      },
    ],
  },
  {
    key: "int_produccion",
    label: "Produccion",
    icon: "ti-home",
    to: "/dashboard",
  },
];

const SidebarContent = props => {
  const location = useLocation();
  const ref = useRef();
  const path = location.pathname;

  // Permissions state
  const [allowedMenus, setAllowedMenus] = useState([]);

  // Get user role/profile
  const userRol = pb.authStore.model?.rol || "default";

  // Fetch allowed menu keys from PocketBase
  useEffect(() => {
    async function fetchMenuPermissions() {
      try {
        const record = await pb.collection("menu_permissions").getFirstListItem(
          `rol="${userRol}"`
        );
        setAllowedMenus(record.menu_items || []);
      } catch (err) {
        setAllowedMenus([]); // fallback: no menu
      }
    }
    fetchMenuPermissions();
  }, [userRol]);

  // MetisMenu activation
  useEffect(() => {
    ref.current && ref.current.recalculate();
    new MetisMenu("#side-menu");
  }, [allowedMenus]);

  // Menu rendering
  function renderMenu(menuList = MENU_CONFIG) {
    return menuList
      .filter(item => allowedMenus.includes(item.key))
      .map(item => {
        const hasSubMenu = Array.isArray(item.subMenu) && item.subMenu.length > 0;
        const allowedSubMenu = hasSubMenu
          ? item.subMenu.filter(sub => allowedMenus.includes(sub.key))
          : [];

        return (
          <li key={item.key}>
            <Link
              to={item.to || "#"}
              className={allowedSubMenu.length > 0 ? "has-arrow waves-effect" : "waves-effect"}
              onClick={e => {
                if (allowedSubMenu.length > 0) e.preventDefault();
              }}
            >
              {item.icon && <i className={item.icon}></i>}
              <span>{props.t(item.label)}</span>
            </Link>
            {allowedSubMenu.length > 0 && (
              <ul className="sub-menu" aria-expanded="false">
                {renderMenu(allowedSubMenu)}
              </ul>
            )}
          </li>
        );
      });
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")}</li>
            {renderMenu()}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));